import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { FilterConfiguration } from './settings/FilterConfiguration';
import { General } from './settings/General';
import { EngagementPlan } from './settings/EngagementPlan';
import { Billing } from './settings/Billing';
import { useViewMode } from '../context/ViewModeContext';
import { SettingsIcon, FilterIcon, BellIcon, UsersIcon, PlugIcon, ClipboardListIcon, CreditCardIcon } from 'lucide-react';
export function Settings() {
  const location = useLocation();
  const {
    viewMode
  } = useViewMode();
  // Brand view settings: Filter config, Notifications, User Management
  const brandSettingsMenuItems = [{
    path: '/settings',
    label: 'Filter Configuration',
    icon: FilterIcon,
    exact: true
  }, {
    path: '/settings/notifications',
    label: 'Notifications',
    icon: BellIcon
  }, {
    path: '/settings/users',
    label: 'User Management',
    icon: UsersIcon
  }];
  // Store view settings: General, Billing, Engagement Plan, Notifications
  const storeSettingsMenuItems = [{
    path: '/settings',
    label: 'General',
    icon: SettingsIcon,
    exact: true
  }, {
    path: '/settings/billing',
    label: 'Billing & Subscription',
    icon: CreditCardIcon
  }, {
    path: '/settings/engagement-plan',
    label: 'Engagement Plan',
    icon: ClipboardListIcon
  }, {
    path: '/settings/notifications',
    label: 'Notifications',
    icon: BellIcon
  }];
  const settingsMenuItems = viewMode === 'brand' ? brandSettingsMenuItems : storeSettingsMenuItems;
  const isActive = (path: string, exact?: boolean) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-3360">
      <Sidebar data-id="element-3361" />
      <main className="flex-1" data-id="element-3362">
        <Header data-id="element-3363" />
        <div className="flex h-[calc(100vh-73px)]" data-id="element-3364">
          {/* Settings Sidebar */}
          <div className="w-64 bg-white border-r border-gray-200 p-4" data-id="element-3365">
            <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 px-3" data-id="element-3366">
              {viewMode === 'brand' ? 'Brand Settings' : 'Store Settings'}
            </h2>
            <nav className="space-y-1" data-id="element-3367">
              {settingsMenuItems.map(item => {
              const Icon = item.icon;
              const active = isActive(item.path, item.exact);
              return <Link key={item.path} to={item.path} className={`flex items-center px-3 py-2 rounded-md text-sm transition-colors ${active ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-3368">
                    <Icon size={18} className="mr-3" data-id="element-3369" />
                    {item.label}
                  </Link>;
            })}
            </nav>
          </div>

          {/* Settings Content */}
          <div className="flex-1 overflow-y-auto p-8" data-id="element-3370">
            <Routes data-id="element-3371">
              {viewMode === 'brand' ? <>
                  <Route path="/" element={<FilterConfiguration data-id="element-3373" />} data-id="element-3372" />
                  <Route path="/notifications" element={<NotificationsPlaceholder data-id="element-3375" />} data-id="element-3374" />
                  <Route path="/users" element={<UsersPlaceholder data-id="element-3377" />} data-id="element-3376" />
                </> : <>
                  <Route path="/" element={<General data-id="element-3379" />} data-id="element-3378" />
                  <Route path="/billing" element={<Billing data-id="element-3381" />} data-id="element-3380" />
                  <Route path="/engagement-plan" element={<EngagementPlan data-id="element-3383" />} data-id="element-3382" />
                  <Route path="/notifications" element={<NotificationsPlaceholder data-id="element-3385" />} data-id="element-3384" />
                </>}
            </Routes>
          </div>
        </div>
      </main>
    </div>;
}
function NotificationsPlaceholder() {
  return <div data-id="element-3386">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-3387">
        Notifications
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-3388">
        Configure your notification preferences
      </p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3389">
        <p className="text-gray-500" data-id="element-3390">Notification settings coming soon...</p>
      </div>
    </div>;
}
function UsersPlaceholder() {
  return <div data-id="element-3391">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-3392">
        User Management
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-3393">Manage team members and permissions</p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3394">
        <p className="text-gray-500" data-id="element-3395">User management coming soon...</p>
      </div>
    </div>;
}